export enum OverdueState {
    Any = 0,
    Yes = 1,
    No = 2
}